/* ─────────────────────────────────────────────
   SOFYRE PDP — sofyre-pdp.js
   ───────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {

  // 1. ANNOUNCEMENT BAR
  var bar = document.getElementById('pdp-bar');
  var barX = document.querySelector('.pdp-bar-x');
  if (bar && sessionStorage.getItem('bar_closed')) bar.style.display = 'none';
  if (barX) barX.addEventListener('click', function () {
    bar.style.display = 'none';
    sessionStorage.setItem('bar_closed', '1');
  });

  // 2. STICKY HEADER SHADOW
  var nav = document.getElementById('pdp-nav');
  window.addEventListener('scroll', function () {
    nav && nav.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });

  // 3. NAV STICKY ATC — show after hero scrolls out
  var hero = document.getElementById('pdp-hero');
  var navAtc = document.getElementById('pdp-nav-atc');
  var navQty = document.getElementById('pdp-nav-qty');

  if (hero && navAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        navAtc.classList.toggle('pdp-nav-atc--visible', !e.isIntersecting);
      });
    }, { threshold: 0 }).observe(hero);
  }

  // 4. IMAGE GALLERY
  var mainImg = document.getElementById('pdp-main-img');
  document.querySelectorAll('.pdp-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.pdp-thumb').forEach(function (x) {
        x.classList.remove('pdp-thumb--active');
      });
      t.classList.add('pdp-thumb--active');
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = t.dataset.src;
          mainImg.style.opacity = '1';
        }, 120);
      }
    });
  });

  // 5. BUNDLE SELECTOR
  var bundles = document.querySelectorAll('.pdp-bundle');
  var mainQty = document.getElementById('pdp-qty');
  var priceEl = document.getElementById('pdp-price');
  var navPriceEl = document.getElementById('pdp-nav-price');

  bundles.forEach(function (b) {
    b.addEventListener('click', function () {
      bundles.forEach(function (x) { x.classList.remove('pdp-bundle--active'); });
      b.classList.add('pdp-bundle--active');
      var qty = parseInt(b.dataset.qty) || 1;
      if (mainQty) mainQty.value = qty;
      if (navQty) navQty.value = qty;
      // Update displayed price (multiply base price by qty)
      var basePrice = parseFloat(b.dataset.base || '0');
      if (basePrice && priceEl) {
        var total = (basePrice * qty / 100).toFixed(2);
        priceEl.textContent = '$' + total;
        if (navPriceEl) navPriceEl.textContent = '$' + total;
      }
    });
  });

  // 6. SCROLL REVEAL
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('on');
          ro.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function (el) { ro.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('on'); });
  }

  // 7. FAQ ACCORDION
  document.querySelectorAll('.pdp-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      var icon = btn.querySelector('.pdp-faq-icon');
      // close all
      document.querySelectorAll('.pdp-faq-q').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var a = document.getElementById(b.getAttribute('aria-controls'));
        if (a) a.hidden = true;
        var ic = b.querySelector('.pdp-faq-icon');
        if (ic) ic.textContent = '+';
      });
      // open clicked if it was closed
      if (!open) {
        btn.setAttribute('aria-expanded', 'true');
        var ans = document.getElementById(btn.getAttribute('aria-controls'));
        if (ans) ans.hidden = false;
        if (icon) icon.textContent = '×';
      }
    });
  });

  // 8. MEDIA & REVIEW TABS
  function initTabs(tabSelector, activeClass) {
    document.querySelectorAll(tabSelector).forEach(function (tab) {
      tab.addEventListener('click', function () {
        document.querySelectorAll(tabSelector).forEach(function (t) {
          t.classList.remove(activeClass);
        });
        tab.classList.add(activeClass);
      });
    });
  }
  initTabs('.pdp-media-tab', 'pdp-media-tab--on');
  initTabs('.pdp-rev-tab', 'pdp-rev-tab--on');

  // 9. ADD BASE PRICE TO BUNDLE OPTIONS (for price calculation)
  var firstBundle = document.querySelector('.pdp-bundle');
  if (firstBundle) {
    var priceText = document.getElementById('pdp-price');
    if (priceText) {
      var raw = priceText.textContent.replace(/[^0-9.]/g, '');
      var baseCents = Math.round(parseFloat(raw) * 100);
      bundles.forEach(function (b) {
        b.dataset.base = baseCents;
      });
    }
  }

});
